import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import * as Types from '@src/components/user-management/types';

export const asyncLoadingMaskAtom = atom(false);
export const panelVisibleAtom = atom(false);

export const userToEditAtom = atomWithReset<null | Types.UserProfileInfo>(null);
export const usersToRevokeAtom = atomWithReset<Types.UserProfileInfo[] | null>(null);
export const toInviteUserAtom = atomWithReset(false);
/** The multi-selected users for the By-User bulk permission edit (map ticket T6 / ISSUE-5). */
export const usersToBulkEditAtom = atomWithReset<Types.UserProfileInfo[] | null>(null);
